<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> warehouse </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor">
          <v-card-title :class="ui.textTitle">
            Update Inventory {{defineIDGShortLastSix(this.inventory.basic.idi)}}
            <v-spacer/>
            {{displayDocumentIDGTypeA(this.inventory.basic.tag, this.inventory.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <div v-if="this.getDetail !== null && this.getDetail.basic.tag === 'L1'"
              class="mb-3">
                <v-layout row :class="ui.textSubheadingBold">
                  <div class="ml-0">
                    Material Detail
                  </div>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm7>
                    <v-text-field
                    v-model="this.getDetail.basic.title"
                    hint="material name"
                    prepend-icon="category"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                    v-model="this.getDetail.char.dis"
                    hint="discipline"
                    prepend-icon="engineering"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mr-2">
                  <v-flex xs12 sm7>
                    <v-text-field
                    v-model="this.getDetail.char.npart"
                    hint="part number"
                    prepend-icon="pin"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm5>
                    <v-text-field
                    v-model="this.getDetail.char.make"
                    hint="vendor"
                    prepend-icon="warehouse"
                    persistent-hint
                    readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Inventory Detail
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="inventory.basic.title"
                  hint="storage name"
                  prepend-icon="title"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="inventory.basic.id"
                  hint="part id"
                  prepend-icon="fingerprint"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="inventory.char.type"
                  hint="type"
                  prepend-icon="grid_view"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="inventory.char.crit"
                  hint="crit."
                  prepend-icon="priority_high"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="inventory.char.haz"
                  hint="hazard"
                  prepend-icon="warning"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                  v-model="inventory.char.owner"
                  hint="owner"
                  prepend-icon="manage_accounts"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="inventory.char.ibound"
                  prepend-icon="login"
                  hint="inbound"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="inventory.char.obound"
                  prepend-icon="logout"
                  hint="outbound"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2 mt-4 mb-2">
                  Stock Level
                </div>
                <v-spacer/>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs6 sm4 offset-sm4>
                  <v-text-field
                  v-model="localForm.stoord"
                  label="ORDER"
                  :rules="ruleNumberPositive"
                  prepend-icon="shopping_bag"
                  hint="available"
                  persistent-hint
                  outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4>
                  <v-text-field
                  v-model="localForm.stocur"
                  label="STOCK"
                  :rules="ruleNumberPositive"
                  prepend-icon="inventory_2"
                  hint="available"
                  persistent-hint
                  outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-model="localForm.com"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="local_shipping"
                  label="STOCK MOVEMENT COMMENT"
                  hint="current stock change comment"
                  persistent-hint
                  outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
              <v-icon left> exit_to_app </v-icon>
                Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate()" :color="ui.btnColor" flat
            :disabled="!(localForm.stocur >= 0)">
              <v-icon left> create </v-icon>
                Update
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import master from "@/data/forms/mixins/master.js";
import activityOptions from "@/data/options/mixins/activityOptions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    master,
    activityOptions,
    rulesTextfield,
    dateFunctions,
    listFunctions,
    docRevsModFunctions,
    numberFunctions,
    financeFunctions,
    apptheme,
    displayFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getInventoryList", "getUser", "getInventoryListCounter", "getDetail"]),
    reactiveInventoryList() {
      return this.getInventoryList;
    }
  },
  props: {
    inventory: {
      type: Object
    }
  },
  data() {
    return {
      hideActions: true,
      dialog: false,
      valid: false,
      enableSpinner: false,
      localForm: {
        com: "",
        stoord: "", // on order
        stocur: "" // available
      }
    };
  },
  beforeMount() {
    this.localForm.stoord = this.inventory.char.stoord;
    this.localForm.stocur = this.inventory.char.stocur;
    this.localForm.com = ""; // leave as blank
    this.localForm.materialTitle = this.getDetail.basic.title;
    this.localForm.materialId = this.getDetail.basic.id;
    this.localForm.materialAvail = this.getDetail.char.avail;
    this.localForm.materialSupply = this.getDetail.char.supply;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    refreshList() {
      let store = "changeInventoryListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getInventoryListCounter + 1);
      this.$store.dispatch(store, this.getInventoryListCounter - 1);
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.saveDocumentRevMod(5.12, 1); // inventory removed.
    },
    validate() {
      // cosole.log(this.taskForm)
      if (this.$refs.form.validate() === true) {
        // hi
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // add dates
        let tempForm = this.inventory;
        // CHAR
        tempForm.char.stocur = this.localForm.stocur;
        tempForm.char.stoord = this.localForm.stoord;
        tempForm.char.com = this.localForm.com;
        // STATS
        tempForm.stats.dedit = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getInventoryList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.changeItemReturnList(parseobj, tempList);
        this.$store.dispatch("changeInventoryList", newList);
        this.refreshList();
        this.dialog = false;
      }
    }
  }
};
</script>
